"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* tslint:disable */

/* eslint-disable */
var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FollowGeneButton_gene",
  "selections": [{
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "internalID",
    "storageKey": null
  }, {
    "alias": "is_followed",
    "args": null,
    "kind": "ScalarField",
    "name": "isFollowed",
    "storageKey": null
  }],
  "type": "Gene"
};
node.hash = '27bbf9c0d8426586f13fe1dacb54b489';
var _default = node;
exports.default = _default;
//# sourceMappingURL=FollowGeneButton_gene.graphql.js.map